import * as SportType from 'constants/SportType';

import Soccer from './Soccer.jsx';
import Default from './Default.jsx';

export default (sportId) => {
    switch (sportId) {
        case SportType.FOOTBALL:
            return Soccer;
        default:
            return Default;
    }
};


// WEBPACK FOOTER //
// ./js/sport-betting/components/grid-control/components/matchStats/sports/factory.js